import React from 'react'
import { Breadcrumb as BreadcrumbAnt } from 'antd'
import { BreadcrumbProps } from 'antd/lib/breadcrumb'

import { useT } from 'src/core/hooks/use-translation'

function Breadcrumb({
  items = [],
  ...props
}: BreadcrumbProps & { items: string[] }): JSX.Element {
  const { t } = useT()
  return (
    <BreadcrumbAnt {...props}>
      {items.map((item: string, index: number) => (
        <BreadcrumbAnt.Item key={index}>{t(item)}</BreadcrumbAnt.Item>
      ))}
    </BreadcrumbAnt>
  )
}

export default Breadcrumb
